import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import camelCase from 'lodash/camelCase';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import { CheckboxButton } from 'sure-components';
import Button from 'shared/lib/components/Button';
import { saveClaimsDeviceDamages, submitClaim } from '../../store/actions';
import DEVICE_DAMAGES from '../../constants/claimsDeviceDamages';
import * as analytics from 'shared/lib/analytics';
import './ClaimsDamages.css';


class ClaimsDamages extends Component {

  constructor(props) {
    super(props);
    analytics.page('Portal - Claim Smartphone Damages', {
      category: 'claim',
    });
  }

  componentDidMount() {
    document.title = `Claims | Damages - Sure`;
  }

  setNextButtonState(damage, i) {
    analytics.track('Portal - Claim Smartphone Damage Clicked', {
      category: 'claim',
      label: damage,
      value: i,
    });
    const selectedDamages = filter(DEVICE_DAMAGES, (damage) => {
      return this[camelCase(damage)].checked;
    });
    this.props.saveClaimsDeviceDamages(selectedDamages);
  }

  handleNext() {
    analytics.track('Portal - Claim Smartphone Damages Next Clicked', {
      category: 'claim',
      value: this.props.claimsDeviceDamages.length,
    });

    const { verticalCode, policyNumber } = this.props.params;

    if (this.props.isClaimsDeviceMailedOut) {
      analytics.track('Portal - Claim Submit Device Mailed Out', {
        category: 'claim',
        nonInteraction: 1,
      });
      this.props
        .submitClaim({
          policyNumber,
          verticalCode,
        })
        .then((response) => {
          analytics.track('Portal - Claim Submit Device Mailed Out Success', {
            category: 'claim',
            nonInteraction: 1,
          });
          this.props.navTo(`/account/claims/${response.claim_id}`);
        })
        .catch(() => {
          analytics.track('Portal - Claim Submit Device Mailed Out Failure', {
            category: 'claim',
            nonInteraction: 1,
          });
        });
    } else {
      this.props.navTo(`/account/claims/new/${verticalCode}/policies/${policyNumber}/damage-description`);
    }
  }

  render() {
    return (
      <div className="ClaimsDamages">
        <div className="Container Container--small">
          <h1 className="ClaimsDamages-heading">
            Why did you need to have your smartphone repaired?
          </h1>
          <div className="ClaimsDamages-choices">
          {DEVICE_DAMAGES.map((damage, i) => (
            <CheckboxButton
              key={i}
              name="damages"
              value={damage}
              title={damage}
              ref={(c) => this[camelCase(damage)] = c}
              checked={includes(this.props.claimsDeviceDamages, damage)}
              onChange={this.setNextButtonState.bind(this, damage, i)}
            />
          ))}
          </div>
          <Button
            disabled={!this.props.claimsDeviceDamages.length || this.props.isSubmittingClaim}
            onClick={this.handleNext.bind(this)}>
            Next
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    claimsDeviceDamages: state.claimsDeviceDamages,
    isSubmittingClaim: state.isSubmittingClaim,
    isClaimsDeviceMailedOut: state.isClaimsDeviceMailedOut,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    navTo: (route) => dispatch(push(route)),
    saveClaimsDeviceDamages: (damages) => dispatch(saveClaimsDeviceDamages(damages)),
    submitClaim: (details) => dispatch(submitClaim(details)),
  };
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(withRouter(ClaimsDamages));
